import { Component, OnInit,Output,EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-cardiframe',
  templateUrl: './cardiframe.component.html',
  styleUrls: ['./cardiframe.component.css']
})
export class CardiframeComponent implements OnInit {

  video: string = "https://paycard.creditclan.com/?platform=6849&amount=5&email=okunuga.oriyomi@gmail.com"
  @Output() close = new EventEmitter();
  @Input() currentUser:any;
  @Input() loan:any;
  @Input() request_id:any;
  loading = false;
  platform:any;
  constructor() {
    document.addEventListener('keyup', function(ev) {
      console.log('Inside Angulat',ev);
   });
   }

  ngOnInit() {
    this.platform = JSON.parse(localStorage.getItem('platform')); 
    this.video = "https://paycard.creditclan.com/ccindex.php?request_id="+this.loan.request_id+"&platform="+this.loan.platform_id+"&amount="+this.platform.CARD_REQUEST_FEE+"&email="+this.loan.customer.email;
    console.log(this.loan,'Card Iframe')
  }

  closeCardIframe(){
    this.close.emit();
  }

}
